// src/v2/pulse/pulseConstants.js
//
// Shared layout constants for the Pulse page interchangeable panes.
import { T } from "../../app/tokens.js";
//
// The four interchangeable panes — Portfolio Command, Attendance Rate,
// Lease Action Windows, and Lease Exposure — reference PULSE_PANE_H so
// any of them can occupy any 2-up grid slot without producing height gaps
// or layout jumps when swapped.
//
// Value is set to the tallest pane's natural collapsed content height after
// the Portfolio Command pane was restructured to a ring-left / meters-right
// side-by-side layout (PULSE-COMMAND-PANE-CONFORM-TO-COMP). The old value
// (428 px) was anchored to the prior stacked layout; the new layout reduces
// Portfolio Command's natural height to ~284 px, which is at parity with
// the Attendance Rate pane's natural height.

export const PULSE_PANE_H = 284;

export const INFOCUS_TILE_H = 140;

// OUTBOUND_LINK_STYLE — shared style for "more/less", "View all N items", and
// "View all N on the Leases board" link-buttons. Static blue so all three are
// visually identical at rest without hover-state tracking.
export const OUTBOUND_LINK_STYLE = {
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  color: "var(--v2-accent)",
  fontSize: T.fsBase,
  fontWeight: T.fwSemibold,
};

export const INFOCUS_SECTION_H = 252;
